import { loadScript } from './utilities';

const loadScriptPromises: { [id: string]: undefined | ReturnType<typeof loadScript> } = {};
export function loadScriptOnce(args: { id: string; src: string }) {
  const { id, src } = args;

  // If already loaded, try to return existing promise
  const exists = !!document.querySelector(`script#${id}`);
  if (exists) {
    const existingPromise = loadScriptPromises[id];
    if (existingPromise) return existingPromise;
    // Perhaps script was loaded by other means. In this case we can't guarantee it has loaded,
    // but would prefer not to throw, as consuming code should also perform checks.
    console.warn(`Skipped loading script with id: ${id}`);
    return Promise.resolve();
  }

  // If not loaded, append to DOM and return onload Promise
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.id = id;
  document.body.appendChild(script);

  const promise = new Promise<void>(resolve => {
    script.onload = () => {
      resolve();
    };
  });
  loadScriptPromises[id] = promise;

  return promise;
}
